import AxiosConfig from '@/config/axios-config'

export default {

  enviarRelatoDuvida (ementaId, texto, url) {
    return AxiosConfig.secureJalekoAPI().post(`/relato-duvida/ementa/${ementaId}/email`, { texto: texto, 'url': url }).then(response => response.data)
  }

}
